import { GridItemNormalizer } from '../types';

export default class SupplierObjectNormalizer implements GridItemNormalizer {
  support(value: any): boolean {
    return value?.__typename === 'object_Supplier';
  }

  normalize(value: any) {
    return value?.legal_name || value?.fact_name;
  }

  normalizeAsSelectValue(value: any) {
    return this.normalize(value);
  }

  getRequiredFields() {
    return {
      id: '',
      legal_name: '',
      fact_name: '',
    };
  }
}
